import { Axios } from 'axios'

import { PBPGetResponse, PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'
import { throttleAsync } from '@percent/utility'
import {
  GetMonetaryVerificationsProps,
  MonetaryVerification,
  MonetaryDonationVerificationCheck,
  MonetaryVerificationDetails,
  SubmitCheckRequestPayload,
  SubmitProfileDataCheckResponse,
  SubmitUboCheckResponse,
  SubmitPaymentDetailsCheckResponse,
  SubmitAdyenSpecificCheckResponse
} from './monetaryVerifications.types'

export const monetaryVerificationsService = ({ percentClient }: { percentClient: Axios }) => ({
  getMonetaryVerifications: throttleAsync(
    (params: GetMonetaryVerificationsProps) =>
      percentClient.get<PBPListResponse<MonetaryVerification>>('/v1/admin/monetary-donation-verifications', { params }),
    1000,
    { leading: true, trailing: true }
  ),
  getMonetaryVerification: ({ id }: { id: string }) =>
    percentClient.get<PBPGetResponse<MonetaryVerificationDetails>>(`/v1/admin/monetary-donation-verifications/${id}`),
  getProfileDataCheck: ({ verificationId }: { verificationId: string }) =>
    percentClient.get<PBPGetResponse<MonetaryDonationVerificationCheck>>(
      `/v1/admin/experience/profile-data-checks/${verificationId}`
    ),
  getUboCheck: ({ verificationId }: { verificationId: string }) =>
    percentClient.get<PBPGetResponse<MonetaryDonationVerificationCheck>>(
      `v1/admin/aml-compliance/ubo-checks/${verificationId}`
    ),
  submitProfileDataCheck: ({ verificationId, model }: { verificationId: string; model: SubmitCheckRequestPayload }) =>
    percentClient.post<SubmitProfileDataCheckResponse>(
      `v1/admin/experience/profile-data-checks/${verificationId}/resolve`,
      model
    ),
  submitUboCheck: ({ verificationId, model }: { verificationId: string; model: SubmitCheckRequestPayload }) =>
    percentClient.post<SubmitUboCheckResponse>(`v1/admin/aml-compliance/ubo-checks/${verificationId}/resolve`, model),
  getPaymentDetailsCheck: ({ verificationId }: { verificationId: string }) =>
    percentClient.get<PBPGetResponse<MonetaryDonationVerificationCheck>>(
      `v1/admin/disbursements/payment-details-checks/${verificationId}`
    ),
  submitPaymentDetailsCheck: ({
    verificationId,
    model
  }: {
    verificationId: string
    model: SubmitCheckRequestPayload
  }) =>
    percentClient.post<SubmitPaymentDetailsCheckResponse>(
      `v1/admin/disbursements/payment-details-checks/${verificationId}/resolve`,
      model
    ),
  getAdyenSpecificCheck: ({ verificationId }: { verificationId: string }) =>
    percentClient.get<PBPGetResponse<MonetaryDonationVerificationCheck>>(
      `v1/admin/partner-specific-checks/adyen-specific-checks/${verificationId}`
    ),
  submitAdyenSpecificCheck: ({ verificationId, model }: { verificationId: string; model: SubmitCheckRequestPayload }) =>
    percentClient.post<SubmitAdyenSpecificCheckResponse>(
      `v1/admin/partner-specific-checks/adyen-specific-checks/${verificationId}/resolve`,
      model
    )
})
